var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { height: "100%", "overflow-y": "auto" } },
    _vm._l(_vm.processedData, function (item) {
      return _c(
        "div",
        {
          key: item.submissionId,
          class: [
            "menu-item",
            { selected: item.submissionId === _vm.selectedSubmissionId },
          ],
          on: {
            click: function ($event) {
              return _vm.selectItem(item)
            },
          },
        },
        [
          _c("input", {
            staticStyle: { display: "none" },
            attrs: { type: "checkbox" },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { followCursor: true, placement: "bottom-end" },
                  expression: "{ followCursor: true, placement: 'bottom-end' }",
                },
              ],
              staticClass: "menu-text",
              attrs: { content: item.menuText },
            },
            [_vm._v(_vm._s(item.menuText))]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "time" }, [
            _vm._v(_vm._s(_vm.formatDate(item.updatedAt))),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }